
import { theme } from "../theme";

export const HeaderStyles = (_) => ({
  toolbar: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    color: theme.palette.primary.black,
  },
  appBar: {
    minHeight: '85px',
    maxHeight: '85px',
    padding: '0 16px',
    width: '100%',
    justifyContent: 'center',
    backgroundColor: theme.palette.primary.white,
    boxShadow: 'none',
    position: 'unset',
    [theme.breakpoints.down('sm')]: {
      minHeight: '85px',
      maxHeight: '125px',
    },
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    "& img": {
      [theme.breakpoints.down('sm')]: {
        width: '128px',
      },
    },
  },
  companyLogo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '10px',
    height: '150px',
    "& img": {
      borderRadius: '5px',
      objectFit: 'cover',
      marginTop: '20px',
      width: '200px',
      maxHeight: '150px',
      [theme.breakpoints.down('sm')]: {
        width: '128px',
      },
    },
  },
  organizationLogo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '70px',
    "& img": {
      borderRadius: '3px',
      objectFit: 'fill',
      width: '200px',
      maxHeight: '70px',
      [theme.breakpoints.down('sm')]: {
        width: '128px',
        maxHeight: '50px',
      },
    },
  },
  wrapperLogout: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.primary.black,
    fontSize: '1rem',
  },
  dialog: {
    maxWidth: 'md',
    title: {
      fontSize: '2.5rem',
      fontWeight: '700',
      color: theme.palette.primary.black,
    },
    content: {
      fontSize: '1.5rem',
      color: theme.palette.primary.black,
    },
    dialogBox: {
      '& .MuiDialog-paper': {
        padding: '56px',
      },
    },
    cancelButton: 'rgba(36, 35, 35, 0.5)',
    ctaButton: theme.palette.primary.black,
  },
  containerImg:{
    display: "flex",
    justifyContent: "center",
    alignItems:"center",
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      gap: '5px'
    },
  }
});

export const PublicHeaderStyles = (theme) => ({
  appBar: {
    backgroundColor: theme.palette.primary.white,
    height: { md: '85px', xs: '80px' },
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',
    padding: { xl: '0 192px', md: '0 2rem', xs: '0 16px' },
  },
  toolbar: {
    justifyContent: { xs: 'space-between' },
    width: '100%',
  },
  mobileMenu: {
    display: { xs: 'flex', md: 'none' },
  },
  menuItems: {
    display: { xs: 'none', md: 'flex' },
    width: { md: '80%' },
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
  wrapperLog: {
    display: 'flex',
    gap: '8px',
  },
  btnSignIn: {
    width: { lg: '192px', xs: '112px' },
    height: { lg: '56px', md: '48px', xs: '40px' },
    fontSize: '1.5rem',
    textTransform: 'none',
    backgroundColor: theme.palette.primary.black,
    color: theme.palette.primary.white,
    '&:hover': { backgroundColor: 'rgba(240, 240, 240, 0.6)', color: theme.palette.primary.black },
  },
});

export const TicketStyles = (_) => ({
  container: {
    width: '100%',
    boxSizing: 'border-box',
    padding: '20px 80px',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      padding: '30px 40px'
    }
  },
  titleHeader: {
    display: 'flex',
    margin: '0 0 5px 0',
    textAlign: 'start',
    fontSize: '18px',
    fontWeight: '700',
    color: theme.palette.primary.black,
  },
  subTitleHeaderHover: {
    '&:hover':{
        cursor: 'pointer',
        textDecoration: 'underline',
        color: theme.palette.primary.main,
    }
  },
  subTitleHeader: {
    margin: 0,
    textAlign: 'start',
    fontSize: '15px',
    fontWeight: '400',
    maxWidth: '100%',
    minHeight: '1%',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
    color: theme.palette.secondary.black,
  },
});

export const GeneralStyles = (_) => ({
  dashCtn: {
    color: theme.palette.primary.black,
    padding: '0 48px',
    [theme.breakpoints.down('md')]: {
      padding: '0px',
    },
  },
  tableCell: {
    fontSize: "1.2rem",
    textAlign: 'center',
    color: theme.palette.secondary.black,
    [theme.breakpoints.down('sm')]: {
      fontSize: "1rem"
    },
  },
  tableColumnHide: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  bottomBorder: {
    borderBottom: "1px solid rgba(224,224,224,1)",
  },
  borderNone: {
    border: "none",
  },
  dialog: {
    dialogBox: {
      "& .MuiDialog-paper": {
        padding: "48px",
      },
    },
    title: {
      fontSize: "2rem",
      fontWeight: "700",
      color: theme.palette.primary.black,
    },
  },
  showPassword: {
    position: 'absolute',
    right: '16px',
    top: '7px',
    color: theme.palette.secondary.black,
  },
  stateError: {
    position: 'absolute',
    bottom: '-25px',
    left: '15px',
    background: theme.palette.primary.white,
    color: theme.palette.error.mediumError,
    padding: '0 8px',
    fontSize: '0.875rem !important',
    '&::first-letter': {
      textTransform: 'capitalize'
    }
  },
  
  //organization
  containerToolbar: {
    padding: "20px 28px",
    borderBottom: "1px solid rgba(224,224,224,1)",
  },
  gridToolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
     flexDirection: 'column'
    }
  },
  containerTitle: {
    padding: '0 0px 48px',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      padding: '0 20px 48px 20px',
    }
  },
  containerFormOrganization: {
    padding: '20px',
    [theme.breakpoints.down('md')]: {
      padding: '0px',
    },
  },
  uploadProfilePic: {
    width: '150px',
    position: 'relative',
    height: '150px',
    borderRadius: '999px',
    border: `1px solid ${theme.palette.primary.white}`,
    filter: 'drop-shadow(0px 0px 1px rgba(36, 55, 71, 0.119))',
    '& img': {
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      objectFit: 'contain',
      objectPosition: '50% 50%',
    },
    [theme.breakpoints.down('md')]: {
      width: '100px',
      height: '100px',
    }
  },
  iconBackground:{
    width: '100%',
    height: '100%',
    color: theme.palette.secondary.mediumGray, 
  },
  iconCamera:{
    background: theme.palette.primary.black,
    color: theme.palette.primary.white,
    position: 'absolute',
    bottom: '0px',
    right: '0px',
    '&:hover': {
        background: theme.palette.primary.black,
        boxShadow: 4,
      },
  },
  input: {
    width: "100%",
    "& .MuiOutlinedInput-root": {
      position: "relative",
      color: theme.palette.secondary.black,
      "& .MuiInputAdornment-root": {
        color: theme.palette.primary.black,
      },
    },
  },
  iconButtonSearch: {
    width: '40px',
    height: '40px',
    color: theme.palette.secondary.black,
    '&:hover': {
      backgroundColor: theme.cards.iconBackground,
    },
  },
  customButtonMain: {
    width: '100%',
    maxHeight: '64px',
    height: '56px',
    fontSize: '1.2rem',
    textTransform: 'none',
    backgroundColor: theme.palette.primary.black,
    color: theme.palette.primary.white,
    '&:hover': {
      backgroundColor: theme.palette.primary.black,
      boxShadow: theme.button.boxShadowBtn,
    },
    '& .MuiButton-endIcon>*:nth-of-type(1)': {
      fontSize: '1.6rem',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      height: '40px',
      fontSize: '1rem',
      '& .MuiButton-endIcon>*:nth-of-type(1)': {
        fontSize: '1.2rem',
      },
      "& .MuiOutlinedInput-root": {
        height: '40px',
      },
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    '&:disabled': {
        backgroundColor: theme.palette.primary.black,
        color: theme.palette.primary.white,
        opacity: '0.2',
    },
  },
  customButton: {
    display: "flex",
    justifyContent: "space-around",
    background: theme.palette.primary.white,
    width: '100%',
    paddingX: "20px",
    height: "56px",
    fontSize: "1.2rem",
    textTransform: "none",
    color: theme.palette.primary.black,
    boxShadow: theme.button.boxShadowBtn,
    lineHeight: "18px",
    position: 'relative',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '4px',
      background: theme.palette.primary.main,
      opacity: 0,
      transition: 'opacity 0.3s ease',
    },
    "& .MuiSvgIcon-root": {
      fontSize: "1.2rem",
      marginLeft: 1,
    },
    "&:hover": {
      background: theme.palette.primary.white,
      transform: 'translateY(-2px)',
      boxShadow: '0 8px 16px 0px rgba(77, 84, 117, 0.4)'
    },
  },
  customButtonSm:{
    [theme.breakpoints.down('md')]: {
      paddingX: "10px",
      height: '40px',
      fontSize: '1rem',
      '& span': {
        '& .MuiSvgIcon-root': {
          fontSize: '1.5rem',
          marginLeft: '5px',
        },
      },
      "& .MuiOutlinedInput-root": {
        height: '40px',
      },
    }
  },
  customCheckbox: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    color: theme.palette.secondary.black,
    '& .MuiFormControlLabel-root': {
      '& .MuiFormControlLabel-label': {
        fontSize: '1.25rem',
        [theme.breakpoints.down('md')]: {
          fontSize: '1rem',
        },
      },
    },
  },
  selectCtn: {
    margin: '16px 0',
  },
});
